module.exports = __webpack_public_path__ + "img/LEAF-K.f115cf0b.svg";